import { render, staticRenderFns } from "./TreeFarm.vue?vue&type=template&id=62231afb&"
import script from "./TreeFarm.vue?vue&type=script&lang=js&"
export * from "./TreeFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports